import React from 'react';
import IfCanAccess from 'src/components/widgets/ifCanAccess/ifCanAccess';
import AddProduct from './addProduct';

export default function AddProductIndex() {
    return (
        <IfCanAccess permission={'PRODUCTS_EDIT'}>
            <AddProduct />
        </IfCanAccess>
    );
}
